import React from "react";
import PropTypes from "prop-types";
import { path } from "ramda";
import { Row, Col, Divider } from "antd";
import { connect } from "react-redux";
import Layout from "../components/layout/Layout";
import I18n from "../i18n";
import UsedSession from "./HomePanels/UsedSession";
import SessionsGraph from "../components/home/SessionsGraph";
import SessionHeader from "../components/form/SessionData";
import Metrics from "../theme/Metrics";
import store, { ReducerKeys } from "../reducers/index";
import { Sessions } from "../util/appointments";
import { withTheme } from "styled-components";
import SessionPanels from "./HomePanels/SessionPanels";
import { FirebaseUtil } from "../util";
import OrganizationActions from "../reducers/OrganizationReducer";

const SessionValues = Object.values(Sessions);

const SessionFilters = Array.from(SessionValues, (k) => (
	{ name: I18n.t(`session_filter.${k}`), value: k }
));

class Home extends React.Component {
    state = {
    	selectSessionIndex: 0,
    	dateRange: null
    }
    async componentDidMount() {
    	const { fetchAppointments,setRoutePermission } = this.props;
    	const { orgID } = store.getState().organization;
			
    	fetchAppointments();
			
    	const routePermission = await FirebaseUtil.getFirebaseRemoteConfig(orgID);
    	if(routePermission) { 
    		await setRoutePermission(routePermission);
    	};
    }
    onFilterChanged(select_value) {
    	const selectSessionIndex = SessionValues.indexOf(select_value);
    	this.setState({ selectSessionIndex });
    }
    onDateChanged(momentDates,stringDates) {
    	// console.log(`Select dateRange [from ${stringDates[0]} to ${stringDates[1]}]`);
    	if(stringDates[0]==="" || stringDates[1] === ""){
    		this.setState({ dateRange:null });
    	}else{
    		this.setState({ dateRange:stringDates });
    	}
    }
    render() {
    	const { dateRange, selectSessionIndex } = this.state;
    	const { appointments } = this.props;
    	const showSessions = selectSessionIndex === 0 ?
    		SessionValues.slice(1) : [SessionValues[selectSessionIndex]];
    	return (<Layout>
    		<SessionHeader
    			optionProps={SessionFilters}
    			selectSessionIndex={selectSessionIndex}
    			dateRange={dateRange}
    			onFilterChanged={this.onFilterChanged.bind(this)}
    			onDateChanged={this.onDateChanged.bind(this)}
    		/>
    		<Divider />
    		<SessionPanels showSessions={showSessions} filterDate={dateRange}/>
    		<Divider />
    		<SessionsGraph appointments={appointments} />
    	</Layout>);
    }
    getChildContext() {
    	const { organization, appointments } = this.props;
    	return { organization, appointments };
    }
    static childContextTypes = {
    	organization: PropTypes.object,
    	appointments: PropTypes.array
    }
}

function state2props(state) {
	return {
		organization: path([ReducerKeys.ORGANIZATION, "organization"], state),
		appointments: path([ReducerKeys.ORGANIZATION, "appointments"], state) || []
	};
}

const mapStateToDispatch = dispatch => ({
	fetchAppointments: () => dispatch(OrganizationActions.getOrganizationAppointmentsRequest()),
	setRoutePermission: (routePermission)=> dispatch(OrganizationActions.setRoutePermission(routePermission))
});

export default connect(state2props, mapStateToDispatch)(Home);


// WEBPACK FOOTER //
// ./src/containers/Home.js